import { isSubscriptionPackage } from './product-catalog-type'

/** How the product form presents a product; the API stores it as the catalog type and add-on flags. */
export type ProductRole = 'product' | 'standalone_add_on' | 'add_on_only' | 'subscription_package'

/** Product form values carry `product_role`; saved products carry the fields it derives from. */
export interface ProductRoleSource {
  product_role?: ProductRole | null
  product_catalog_type?: string | null
  is_add_on?: boolean | null
  is_add_on_only?: boolean | null
}

export function getProductRole(product: ProductRoleSource | null | undefined): ProductRole {
  if (product?.product_role) {
    return product.product_role
  }

  if (isSubscriptionPackage(product)) {
    return 'subscription_package'
  }

  if (product?.is_add_on_only) {
    return 'add_on_only'
  }

  if (product?.is_add_on) {
    return 'standalone_add_on'
  }

  return 'product'
}
